import type { ShowcaseRepository } from "../application/showcase-repository";
import type { ComponentCategory, ComponentKind, ShowcaseComponent } from "../domain/showcase-component";

const component = (
  id: string,
  title: string,
  description: string,
  kind: ComponentKind,
  configurations: number,
  category: ComponentCategory = "common",
): ShowcaseComponent => ({ id, title, description, category, kind, configurations });

const canonicalCatalog: ReadonlyArray<[string, string]> = [
  ["Actions", "DSButton,DSButtonSecondary,DSButtonGhost,DSButtonDanger,DSIconButton,DSButtonGroup,DSFloatingActionButton,DSLink,DSToolbar"],
  ["Inputs", [
    "DSTextField", "DSTextArea", "DSSearchField", "DSSelect", "DSCombobox", "DSCheckbox",
    "DSRadio", "DSSwitch", "DSSlider", "DSDatePicker", "DSTimePicker", "DSFileUpload",
    "DSPinInput", "DSRating", "DSFormField", "DSFieldset", "DSNumberField", "DSSegmentedControl",
  ].join(",")],
  ["Navigation", [
    "DSNavbar", "DSSidebar", "DSTabs", "DSBreadcrumb", "DSPagination", "DSStepper",
    "DSMenu", "DSCommandPalette", "DSBottomNavigation", "DSTabBar",
  ].join(",")],
  ["Data display", [
    "DSCard", "DSList", "DSTable", "DSBadge", "DSChip", "DSAvatar", "DSAccordion",
    "DSCarousel", "DSStat", "DSTimeline", "DSTree", "DSKeyValue", "DSCodeBlock", "DSDiffViewer",
  ].join(",")],
  ["Feedback", "DSAlert,DSToast,DSProgress,DSSpinner,DSSkeleton,DSEmptyState,DSErrorState,DSStatus,DSBanner"],
  ["Overlay", "DSModal,DSDrawer,DSPopover,DSTooltip,DSContextMenu,DSDialog"],
  ["Layout", [
    "DSContainer", "DSStack", "DSInline", "DSGrid", "DSDivider", "DSSpacer", "DSAppShell",
    "DSSection", "DSAspectRatio", "DSScrollArea", "DSPageHeader", "DSSplitView", "DSPanel", "DSSplitPane",
  ].join(",")],
  ["Media", "DSImage,DSVideo,DSIcon,DSLogo,DSImageGallery"],
  ["Content", "DSMarkdownContent"],
];

const canonicalComponents: ReadonlyArray<ShowcaseComponent> = canonicalCatalog.flatMap(([category, names]) =>
  names.split(",").map((name) => ({
    id: name,
    title: name,
    description: `Componente canónico · ${category}`,
    category: "common" as const,
    kind: "canonical" as const,
    configurations: 3,
    canonicalCategory: category,
  })),
);

const components: ReadonlyArray<ShowcaseComponent> = [
  ...canonicalComponents,
  component("push-workout", "Entrenamiento activo", "Serie actual, descanso y progreso", "push-workout", 3, "push"),
  component("agenda-plan", "Plan recomendado", "Vigencia, distancia y procedencia", "agenda-plan", 3, "agenda"),
  component("opo-question", "Pregunta explicada", "Respuesta, explicación y revisión", "opo-question", 3, "opo"),
  component(
    "visagismo-guide",
    "Recomendación visual",
    "Opción probable y alternativas",
    "visagismo-guide",
    3,
    "visagismo",
  ),
];

export class StaticShowcaseRepository implements ShowcaseRepository {
  public list(): ReadonlyArray<ShowcaseComponent> {
    return components;
  }
}
